import React, { useState, useEffect, useCallback, Fragment } from 'react';
import { Card, CardBody, CardHeader, Col, Row, Button, Table, Badge } from 'reactstrap';
import { useNavigate } from 'react-router-dom';
import { MdAdd, MdEdit, MdDelete, MdSettings } from 'react-icons/md';

// components
import Page from '../components/Page';
// My components
import ReactDataTable from '../mycomponents/ReactDataTable';
// lib
import { dateTimeFormat } from '../lib/date';
import toastAlert from '../lib/toastAlert';
// api
import { getTestimonial, updateTestimonialStatus, deleteTestimonial } from '../api/admin';


const WorkList = () => {

    const navigate = useNavigate();

    const columns = [
        {
            key: "name",
            text: "Name",
            className: "name",
            align: "left",
            sortable: false,
            cell: ({ name }) => {
                if (name.length > 100) {
                    return `${name?.substring(0, 100)}...`
                } else return name;
            }
        },
        {
            key: "category",
            text: "Category",
            className: "category",
            align: "left",
            sortable: false
        },
        {
            key: "side",
            text: "Side",
            className: "side",
            align: "left",
            sortable: false
        },
        {
            key: "status",
            text: "Status",
            className: "status",
            align: "left",
            sortable: false,
            cell: ({ _id, status }) => {
                return (
                    <Badge
                        color={status === 'Active' ? "success" : "danger"}
                        style={{ fontSize: "12px", padding: "10px 16px", borderRadius: "10px", cursor: "pointer" }}
                        onClick={() => handleStatusChange({ _id, status })}
                    >
                        {status}
                    </Badge>
                )
            }
        },
        {
            key: "createdAt",
            text: "Created At",
            className: "createdAt",
            align: "left",
            sortable: false,
            cell: ({ createdAt }) => {
                return dateTimeFormat(createdAt)
            }
        },
        {
            key: "action",
            text: "Action",
            className: "action",
            align: "left",
            sortable: false,
            cell: state => {
                return (
                    <div style={{ display: 'flex', gap: '8px' }}>
                        <Button
                            color="secondary"
                            onClick={
                                () => navigate('/testimonial-edit', { state })}
                        >
                            <MdEdit />
                        </Button>
                        <Button
                            color="danger"
                            onClick={() => handleDelete({ _id: state?._id })}
                        >
                            <MdDelete />
                        </Button>
                    </div>
                )
            }
        }
    ];


    // state
    const [data, setData] = useState([]);
    const [count, setCount] = useState(0);
    const [loader, setLoader] = useState(false);
    const [pagination, setPagination] = useState({ page: "", limit: "", search: "" });
    // const { page, limit, search } = pagination;

    const handleStatusChange = async (data) => {
        try {
            let { status, message } = await updateTestimonialStatus(data);
            if (status === true) {
                toastAlert('success', message, 'updateTestimonialStatus')
                fetchData();
            }
        } catch (error) { }
    }

    const handleDelete = async (data) => {
        try {
            if (window.confirm('Are you sure want to delete this record?')) {
                let { status, message } = await deleteTestimonial(data);
                if (status === true) {
                    toastAlert('success', message, 'deleteTestimonial')
                    fetchData();
                }
            }
        } catch (error) { }
    }

    const fetchData = useCallback(async () => {
        try {
            setLoader(true);
            const { status, result } = await getTestimonial(pagination);
            setLoader(false);
            if (status === true) {
                setData(result.data)
                setCount(result.count)
            }
        } catch (err) { }
    }, [pagination])

    useEffect(() => {
        fetchData()
    }, [pagination, fetchData])

    return (
        <Page
            title="Testimonial List"
            breadcrumbs={[{ name: 'Testimonial List', active: true }]}
            className="TablePage"
        >
            <Row>
                <Col>
                    <Card className="mb-3">
                        <CardHeader className="d-flex align-items-center justify-content-between">
                            <span>Testimonial List</span>
                            <Button color="primary" onClick={() => navigate('/testimonial-add')}><MdAdd />Add</Button>
                        </CardHeader>
                        <CardBody>
                            <Table responsive={false}>
                                <ReactDataTable
                                    columns={columns}
                                    records={data}
                                    count={count}
                                    loader={loader}
                                    setPagination={setPagination}
                                />
                            </Table>
                        </CardBody>
                    </Card>
                </Col>
            </Row>
        </Page>
    );
};

export default WorkList;